<template>

  <div class="container">
    <div class="col">
      <el-dialog :visible.sync="dialogTableVisible">
        <div>
          <div class="col">
            <el-tag size="medium">
              recomendado
            </el-tag>
          </div>
          <el-button class="item">
            JS
          </el-button>
        </div>
        <el-divider />
        <h2 class="ant-typography">
          Código JS
        </h2>
        <div class="col">

          <div class="row justify-content-end">
            <div class="col-1">
              <i
                class="el-icon-document-copy"
                @click="copiarTexto()"
              />
            </div>

          </div>

          <div
            id="content___1YRKM"
            class="player-card-modal-textarea "
          >
            <textarea
              id="texto"
              readonly=""
              class="ant-input"
            >
 &lt;div class="chat-script"&gt;
     &lt;script type="text/javascript"&gt;
        (function (w, r, l, d) {
            try {
                var h = r.head || r.getElementsByTagName("head")[0], s = r.createElement("script");
                s.defer = true;
                s.setAttribute("type", "module");
                s.setAttribute("src", l);
                w.idbooster = d;
                h.appendChild(s);
            } catch (e) {
            }
        })(window, document, "{{ VUE_APP_HOST_BUCKET_CHAT }}", "{{ getUserData.uuid }}");
    &lt;/script&gt;
&lt;/div&gt;
           </textarea>
          </div>

        </div>
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button @click="dialogTableVisible = false">Cancel</el-button>
        </span>
      </el-dialog>
    </div>
    <b-modal
      id="modal-prevent-closing"
      ref="my-modal"
      title="Criação de Fluxo"
      modal-class="dk-create-flow-modal"
      centered
      ok-title="Salvar"
      cancel-variant="outline-secondary"
      hide-footer
      size="lg"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <div class="dk-create-flow">
        <p class="dk-create-flow__intro">
          Escolha um modelo para criar seu fluxo. O domínio do perfil será aplicado automaticamente no novo chat.
        </p>
        <div class="dk-create-flow__section-title">Fluxo padrão</div>
        <div
          class="dk-create-flow__grid"
        >
          <div
            class="dk-create-flow__item dk-create-flow__item--featured"
            :class="{ 'dk-create-flow__item--loading': creatingChat }"
            @click="criarChat(modeloP)"
          >
            <CardModeloChat
              avatar="https://chat-booster.s3.amazonaws.com/img/avata_defaults/Ramon.png"
              titulo="Gere leads interessantes para o marketing digital da sua empresa(?)"
              :tags="['Padrão']"
            />
          </div>
        </div>
        <div class="dk-create-flow__section-title">Modelos</div>
        <div class="dk-create-flow__grid">
          <div
            v-for="modelo in modelos"
            :key="modelo.avatar"
            class="dk-create-flow__item"
            :class="{ 'dk-create-flow__item--loading': creatingChat }"
            @click="createModeloChat(modelo)"
          >
            <CardModeloChat
              :avatar="modelo.json.design.avatar"
              :titulo="modelo.json.chamadaInicial"
              :tags="modelo.tags"
              :cor="modelo.cor"
            />
          </div>
        </div>
      </div>
    </b-modal>
    <b-form-input
      v-if="getUserData.user_role !== 'admin'"
      id="input-domain-user"
      v-model="domainUser"
      placeholder="Digite o domínio do site, Ex.: www.meusite.com.br"
      class="mb-1"
      @blur="updateDomainUser"
    />
    <small v-if="getUserData.user_role !== 'admin'" class="dk-domain-hint">
      Dominio usado nos novos fluxos: <strong>{{ domainUser || 'não informado' }}</strong>
    </small>

    <!-- ── Stats do Chat ── -->
    <div class="dk-chat-stats">
      <div class="dk-chat-stat">
        <div class="dk-chat-stat__icon dk-chat-stat__icon--total">
          <i class="el-icon-chat-dot-round" />
        </div>
        <div class="dk-chat-stat__info">
          <div class="dk-chat-stat__val">{{ chats.length }}</div>
          <div class="dk-chat-stat__label">Total de chats</div>
        </div>
      </div>
      <div class="dk-chat-stat">
        <div class="dk-chat-stat__icon dk-chat-stat__icon--active">
          <i class="el-icon-circle-check" />
        </div>
        <div class="dk-chat-stat__info">
          <div class="dk-chat-stat__val">{{ chatsAtivos }}</div>
          <div class="dk-chat-stat__label">Ativos</div>
        </div>
      </div>
      <div class="dk-chat-stat">
        <div class="dk-chat-stat__icon dk-chat-stat__icon--started">
          <i class="el-icon-user" />
        </div>
        <div class="dk-chat-stat__info">
          <div class="dk-chat-stat__val">{{ analytics.total_started || 0 }}</div>
          <div class="dk-chat-stat__label">Conversas iniciadas</div>
        </div>
      </div>
      <div class="dk-chat-stat">
        <div class="dk-chat-stat__icon dk-chat-stat__icon--finished">
          <i class="el-icon-trophy" />
        </div>
        <div class="dk-chat-stat__info">
          <div class="dk-chat-stat__val">{{ analytics.total_finished || 0 }}</div>
          <div class="dk-chat-stat__label">Conversas finalizadas</div>
        </div>
      </div>
      <div class="dk-chat-stat">
        <div class="dk-chat-stat__icon dk-chat-stat__icon--rate">
          <i class="el-icon-data-analysis" />
        </div>
        <div class="dk-chat-stat__info">
          <div class="dk-chat-stat__val">{{ engajamento }}%</div>
          <div class="dk-chat-stat__label">Taxa de conversao</div>
        </div>
      </div>
    </div>

    <!-- ── Trial expired overlay for Chat ── -->
    <div v-if="isTrialExpired" class="dk-trial-chat-block">
      <div class="dk-trial-chat-block__card">
        <div class="dk-trial-chat-block__icon">
          <svg width="32" height="32" fill="none" viewBox="0 0 24 24">
            <rect x="3" y="11" width="18" height="11" rx="2" stroke="currentColor" stroke-width="2"/>
            <path d="M7 11V7a5 5 0 0110 0v4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </div>
        <h3 class="dk-trial-chat-block__title">Chat Booster bloqueado</h3>
        <p class="dk-trial-chat-block__text">
          Seu período de teste de 30 dias expirou.<br>
          Faça upgrade para continuar usando o Chat Booster.
        </p>
        <a :href="kiwifyCheckoutUrl" target="_blank" class="dk-trial-chat-block__btn">
          <svg width="14" height="14" fill="none" viewBox="0 0 24 24">
            <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <polyline points="17 8 12 3 7 8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <line x1="12" y1="3" x2="12" y2="15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          Fazer Upgrade
        </a>
      </div>
    </div>

    <!-- ── Chat Grid ── -->
    <div class="dk-chat-grid" :class="{ 'dk-chat-grid--disabled': isTrialExpired }">
      <div
        v-for="chat in chats"
        :key="chat.id"
        class="dk-chat-card"
      >
        <!-- Top: Avatar + Status -->
        <div class="dk-chat-card__top">
          <div class="dk-chat-card__avatar-wrap">
            <img
              :src="resolveChatAvatar(chat)"
              class="dk-chat-card__avatar"
              alt=""
              @error="onAvatarError"
            >
            <span
              class="dk-chat-card__status-dot"
              :class="chat.status === 1 ? 'dk-chat-card__status-dot--on' : 'dk-chat-card__status-dot--off'"
              :title="chat.status === 1 ? 'Ativo' : 'Inativo'"
            />
          </div>
          <div class="dk-chat-card__actions">
            <b-form-checkbox
              :checked="chat.status === 1"
              class="custom-control-success"
              name="check-button"
              switch
              inline
              @change="changeStatus(chat)"
            />
            <el-dropdown>
              <button class="dk-chat-card__more-btn">
                <feather-icon icon="MoreVerticalIcon" size="16" />
              </button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="duplicarChat(chat)">
                  <feather-icon icon="CopyIcon" size="14" class="mr-50" />
                  <span>Duplicar</span>
                </el-dropdown-item>
                <el-dropdown-item @click.native="showModalDelete1(chat.id)">
                  <feather-icon icon="TrashIcon" size="14" class="mr-50" style="color:#C12B2B" />
                  <span style="color:#C12B2B">Remover</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>

        <!-- Body: Name + Message -->
        <div class="dk-chat-card__body" @click="editChat(chat)">
          <span class="dk-chat-card__name">{{ chat.name }}</span>
          <span class="dk-chat-card__msg" v-html="chat.chamadaInicial" />
          <span class="dk-chat-card__domain">
            <feather-icon icon="GlobeIcon" size="11" class="dk-chat-card__domain-icon" />
            <span v-if="chat.domain" class="dk-chat-card__domain-text" :title="chat.domain">{{ chat.domain }}</span>
            <span v-else class="dk-chat-card__domain-text dk-chat-card__domain-text--empty">Sem URL vinculada</span>
          </span>
        </div>

        <!-- Footer: Edit button -->
        <div class="dk-chat-card__footer">
          <button class="dk-chat-card__edit-btn" @click.stop="editChat(chat)">
            <feather-icon icon="EditIcon" size="14" />
            Editar
          </button>
        </div>
      </div>

      <!-- Empty state -->
      <div v-if="chats.length === 0" class="dk-chat-empty">
        <feather-icon icon="MessageSquareIcon" size="40" />
        <p>Nenhum fluxo criado</p>
        <p class="dk-chat-empty__sub">Clique em "Criar Fluxo" para começar</p>
      </div>
    </div>
    <b-modal
      id="modal-fluxo"
      title="Confirmação de exclusão de Fluxo"
      cancel-title="cancelar"
      cancel-variant="outline-secondary"
      ok-variant="danger"
      ok-title="Deletar"
      centered
      @ok="deletarChat()"
    >
      <b-card-text>
        <slot name="content-message">
          Tem certeza de que deseja <strong>excluir</strong> esse Fluxo?
        </slot>
      </b-card-text>
    </b-modal>
  </div>
</template>

<script>

import {
  BButton, BFormGroup, BFormInput, BModal, VBModal, BListGroup, BListGroupItem, BFormCheckboxGroup, BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { useApi } from '@/composables/useApi'
import CardModeloChat from '@/views/App/Chat/CardModeloChat.vue'
import Integrations from '@/views/App/Integracoes/Index.vue'
import TabsIcons from '@/components/TabsCustom/TabsIcons.vue'
import trialMixin from '@/mixins/trialMixin'
import {
  modelo1, modelo2, modelo3, modelo4, modelo5,
} from './modelos'

const apiBack = useApi()
export default {
  mixins: [trialMixin],
  components: {
    TabsIcons,
    CardModeloChat,
    BButton,
    BFormGroup,
    BFormInput,
    BListGroup,
    BListGroupItem,
    BModal,
    BFormCheckboxGroup,
    BFormCheckbox,
    Integrations,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      isValidDomain: false,
      domainUser: '',
      creatingChat: false,
      idChat: {},
      dialogTableVisible: false,
      name: '',
      nameState: null,
      fluxoSelecionado: '',
      chats: [],
      analytics: {},
      tabsPrincipal: [
        {
          icon: 'HomeIcon',
          title: 'Meus Fluxos',
          component: 'Integrations',
          rota: '/app/chat',
          active: true,
        },
        {
          icon: 'PlusIcon',
          title: 'Criar Fluxo',
          component: 'Integrations',
          rota: '/app/chat',
          active: false,
        },
        {
          icon: 'SettingsIcon',
          title: 'Integrações',
          component: 'Integrations',
          rota: '/app/chat',
          active: false,
        },
      ],
      modeloP: {
        avatar: 'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Bruna.png',
        titulo: 'Gere leads interessantes para o marketing digital da sua empresa(?)',
        tags: ['Agencia de Marketing'],
        json: modelo5,
      },
      modelos: [
        {
          avatar: 'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Bruna.png',
          titulo: 'Gere leads interessados em marketing digital para empresas',
          tags: ['Agencia de Marketing'],
          cor: '#FF0000',
          json: modelo1,
        },
        {
          avatar: 'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Kim.png',
          titulo: 'Gere leads interessados em tecnologia para empresas',
          tags: ['Serviços de Tecnologia'],
          cor: '#FFA500',
          json: modelo2,
        },
        {
          avatar: 'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Ramon.png',
          titulo: 'Gere leads interessados em Contabilidade para empresas',
          tags: ['Contabilidade'],
          cor: '#FFFF00',
          json: modelo3,
        },
        {
          avatar: 'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Harumi.png',
          titulo: 'Gostaria de se consultar com um advogado online?',
          tags: ['Advocacia'],
          cor: '#008000',
          json: modelo4,
        },
      ],
    }
  },
  computed: {
    chatsAtivos() {
      return this.chats.filter(c => c.status === 1 || c.status === '1').length
    },
    engajamento() {
      const s = this.analytics.total_started || 0
      const f = this.analytics.total_finished || 0
      if (!s) return '0'
      return ((f / s) * 100).toFixed(1)
    },
    VUE_APP_HOST_BUCKET_CHAT() {
      const origin = (typeof window !== 'undefined' && window.location.origin) || ''
      return `${origin}/js/booster.min.js`
    },
    getUserData: {
      get() {
        const newUserData = JSON.parse(localStorage.getItem('userData'))
        if (newUserData !== null) {
          return newUserData
        }
        return {}
      },
      set(value) {
        localStorage.setItem('userData', JSON.stringify(value))
      },
    },
  },
  async mounted() {
    await this.hydrateUserDomainFromProfile()
    this.domainUser = this.resolvePreferredDomain()
    await this.listaChat()
    this.loadAnalytics()
    this.$root.$on('open-criar-fluxo', this.openModal)
  },
  beforeDestroy() {
    this.$root.$off('open-criar-fluxo', this.openModal)
  },
  methods: {
    async hydrateUserDomainFromProfile() {
      try {
        const { data } = await apiBack.get(`/usuario/${this.getUserData.id}`)
        const profile = Array.isArray(data) ? data[0] : data
        if (!profile) return
        const onboardingDomain = this.normalizeDomain(profile.user_onboarding_site_url)
        const fallbackDomain = this.normalizeDomain(profile.user_domain)
        const resolved = onboardingDomain || fallbackDomain
        if (!resolved) return
        this.getUserData = {
          ...this.getUserData,
          user_onboarding_site_url: resolved,
          user_domain: resolved,
        }
      } catch (_) {
        // silencioso: mantém fallback do localStorage
      }
    },
    normalizeDomain(value) {
      const raw = String(value || '').trim()
      if (!raw) return ''
      const noProtocol = raw.replace(/^https?:\/\//i, '')
      const cutPath = noProtocol.split('/')[0]
      return cutPath.toLowerCase()
    },
    resolvePreferredDomain() {
      const user = this.getUserData || {}
      const profileDomain = this.normalizeDomain(user.user_onboarding_site_url)
      const chatDomain = this.normalizeDomain(user.user_domain)
      return profileDomain || chatDomain || ''
    },
    getChatIdFromCreateResponse(data) {
      if (!data) return null
      if (data.id) return data.id
      if (data.chat && data.chat.id) return data.chat.id
      if (Array.isArray(data.json) && data.json[0] && data.json[0].id) return data.json[0].id
      return null
    },
    async syncDomainOnNewChat(domain) {
      if (!domain) return
      await apiBack.put(`/setDoaminByIdUser?id_user=${this.getUserData.id}&domain=${domain}`)
    },
    async syncChatDesignAfterCreate(chatId, json) {
      if (!chatId || !json || !json.design) return
      const d = json.design
      await apiBack.put(`/chatd/${chatId}`, {
        avatar: d.avatar || '',
        color: d.color || '#000000',
        side: d.side != null ? d.side : 1,
        subTitle: d.subTitle || 'Online Agora',
        title: d.title || 'Chat Booster - Name',
      })
    },
    resolveChatAvatar(chat) {
      return chat.foto || chat.avatar || 'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Ramon.webp'
    },
    onAvatarError(e) {
      e.target.src = 'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Ramon.webp'
    },
    async loadAnalytics() {
      try {
        const { data } = await apiBack.get(`/analytics/all/${this.getUserData.id}`)
        if (data && data[0]) this.analytics = data[0]
      } catch (e) { /* silencioso */ }
    },
    editChat(chat) {
      this.$store.commit('AppChatbooster/SET_CURRENT_TAB', {
        title: 'Gerenciar Fluxos',
        component: 'designChat',
      })
      this.$router.push({ query: { id_chat: chat.id } }).catch(() => {})
    },
    async updateDomainUser() {
      this.domainUser = this.normalizeDomain(this.domainUser)

      if (this.domainUser === '') {
        this.$message({
          message: 'Informe um domínio válido',
          type: 'error',
        })
        return
      }
      await apiBack.put(`/usuario/${this.getUserData.id}`, {
        user_name: this.getUserData.user_name,
        user_email: this.getUserData.user_email,
        user_phone: this.getUserData.user_phone,
        user_sobrenome: this.getUserData.user_sobrenome,
        user_domain: this.domainUser,
        user_onboarding_site_url: this.domainUser,
      })
        .then(async () => {
          this.getUserData = JSON.parse(JSON.stringify({
            ...this.getUserData,
            user_domain: this.domainUser,
            user_onboarding_site_url: this.domainUser,
          }))
          this.$message({
            message: 'Domínio atualizado com sucesso',
            type: 'success',
          })
          await apiBack.put(`/setDoaminByIdUser?id_user=${this.getUserData.id}&domain=${this.domainUser}`)
        })
        .catch(() => {
          this.$message({
            message: 'Error ao atualizar o domínio',
            type: 'error',
          })
        })
    },
    copiarTexto() {
      const textoCopiado = document.getElementById('texto')
      textoCopiado.select()
      textoCopiado.setSelectionRange(0, 99999)
      document.execCommand('copy')
      this.$message({
        message: 'Código de embed JS copiado para área de transferência',
        type: 'success',
      })
    },
    embed(chat) {
      this.idChat = chat.id
    },
    async listaChat() {
      await apiBack.get(`/chat/${this.getUserData.id}`)

        .then(data => {
          this.chats = data.data
        })
        .catch(err => console.error(err))
    },
    showModalDelete1(item) {
      console.log('modaldelete', item)
      this.fluxoSelecionado = item
      this.$bvModal.show('modal-fluxo')
    },
    openModal() {
      this.$refs['my-modal'].show()
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.nameState = valid
      return valid
    },
    resetModal() {
      this.name = ''
      this.nameState = null
    },
    handleOk() {
      if (this.name) {
        this.criarChat()
        this.$refs['my-modal'].hide()
      } else {
        this.nameState = false
      }
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }
      // Push the name to submitted names
      this.submittedNames.push(this.name)
      // Hide the modal manually
      this.$nextTick(() => {
        this.$refs['my-modal'].toggle('#toggle-btn')
      })
    },
    async criarChat(modelo) {
      await this.createChatFromModel(modelo)
    },
    async deletarChat() {
      await apiBack.delete(`/chat/${this.fluxoSelecionado}`)

        .then(response => {
          this.listaChat()
          this.$message({
            type: 'success',
            message: 'Deletado com sucesso',
          })
        })
        .catch(err => console.error(err))
    },
    async createModeloChat(modelo) {
      await this.createChatFromModel(modelo)
    },
    async createChatFromModel(modelo) {
      if (this.creatingChat) return
      this.creatingChat = true
      const domain = this.resolvePreferredDomain()
      try {
        if (!domain) {
          this.$message({
            type: 'warning',
            message: 'Informe o domínio no perfil antes de criar um novo fluxo.',
          })
          return
        }

        const json = JSON.parse(JSON.stringify(modelo.json || {}))
        json.domain = domain
        const { data } = await apiBack.post('/duplicarChat?is_copy=true', {
          id_user: this.getUserData.id,
          json,
        })
        const createdChatId = this.getChatIdFromCreateResponse(data)
        await this.syncChatDesignAfterCreate(createdChatId, json)
        await this.syncDomainOnNewChat(domain)
        await this.listaChat()
        this.$refs['my-modal'].hide()
        if (createdChatId) {
          this.$router.push({ query: { id_chat: createdChatId } }).catch(() => {})
        } else if (this.chats.length) {
          this.$router.push({ query: { id_chat: this.chats[0].id } }).catch(() => {})
        }

        this.$store.commit('AppChatbooster/SET_CURRENT_TAB', {
          title: 'Gerenciar Fluxos',
          component: 'designChat',
        })
        this.$message({
          type: 'success',
          message: 'Fluxo criado com sucesso',
        })
      } catch (err) {
        console.error(err)
        this.$message({
          type: 'error',
          message: 'Não foi possível criar o fluxo',
        })
      } finally {
        this.creatingChat = false
      }
    },
    async duplicarChat(chat) {
      await apiBack.get(`/chatInner/${chat.id}`).then(async resp => {
        const originalJson = resp.data.json[0]
        const created = await apiBack.post('/duplicarChat', {
          json: resp.data.json[0],
          id_user: this.getUserData.id,
        })
        const createdChatId = this.getChatIdFromCreateResponse(created.data)
        await this.syncChatDesignAfterCreate(createdChatId, originalJson)
        this.listaChat()
        this.$message({
          type: 'success',
          message: 'Duplicado com sucesso',
        })
      }).catch(err => console.error(err))
    },
    getValueBoolean(value) {
      return ['true', true, 1, '1'].indexOf(value) !== -1 ? 1 : 0
    },
    async changeStatus(chat) {
      chat.status = !this.getValueBoolean(chat.status)
      await apiBack.put(`/chat/${chat.id}`, { ...chat, status: this.getValueBoolean(chat.status) })
        .then(() => {
          this.listaChat()
        })
        .catch(err => console.error(err))
    },
  },

}
</script>

<style lang="scss" scoped>
@import '~animate.css/animate.min.css';
@import '@/assets/scss/modaEmbedCardVideos/modalEmbedPlayVideo.scss';
@import '@/assets/scss/card_videos/CardVideos.scss';

$dk-orange: #E86A10;
$dk-navy: #0D3349;

.container { margin-top: 16px; }
.b-card { border: none; }
.dk-domain-hint {
  display: block;
  margin: -2px 0 10px;
  color: var(--dk-text-muted, #8a94a6);
  font-size: 11.5px;
}
.dk-domain-hint strong {
  color: var(--dk-text-secondary, #475569);
  font-weight: 700;
}

// ── Create flow modal ───────────────────────────
.dk-create-flow { padding: 2px 2px 6px; }
.dk-create-flow__intro {
  margin: 2px 0 12px;
  color: var(--dk-text-secondary, #475569);
  font-size: 0.86rem;
}
.dk-create-flow__section-title {
  margin: 10px 0 8px;
  color: var(--dk-text-primary, #0D3349);
  font-size: 1rem;
  font-weight: 800;
}
.dk-create-flow__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}
.dk-create-flow__item {
  border: 1px solid var(--dk-border, #e2e8f0);
  border-radius: 12px;
  padding: 8px;
  background: var(--dk-bg-card, #fff);
  cursor: pointer;
  transition: border-color .15s, box-shadow .15s, transform .15s;
}
.dk-create-flow__item:hover {
  border-color: rgba(232,106,16,.35);
  box-shadow: 0 8px 22px rgba(232,106,16,.14);
  transform: translateY(-1px);
}
.dk-create-flow__item--featured {
  grid-column: 1 / -1;
}
.dk-create-flow__item--loading {
  opacity: .55;
  pointer-events: none;
}

// ── Chat Stats ──────────────────────────────────────
.dk-chat-stats {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
  margin-bottom: 20px;
}
.dk-chat-stat {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: var(--dk-bg-card, #fff);
  border: 1px solid var(--dk-border, #e2e8f0);
  border-radius: 12px;
}
.dk-chat-stat__icon {
  width: 40px; height: 40px; border-radius: 10px;
  display: flex; align-items: center; justify-content: center;
  font-size: 18px; flex-shrink: 0;
}
.dk-chat-stat__icon--total { background: rgba(232,106,16,0.1); color: #E86A10; }
.dk-chat-stat__icon--active { background: rgba(16,185,129,0.1); color: #10B981; }
.dk-chat-stat__icon--started { background: rgba(59,130,246,0.1); color: #3B82F6; }
.dk-chat-stat__icon--finished { background: rgba(245,185,53,0.1); color: #F5B935; }
.dk-chat-stat__icon--rate { background: rgba(139,92,246,0.1); color: #8B5CF6; }
.dk-chat-stat__val { font-size: 20px; font-weight: 800; color: var(--dk-text-primary, #0D3349); line-height: 1; }
.dk-chat-stat__label { font-size: 11px; color: var(--dk-text-muted, #8a94a6); margin-top: 2px; }
@media (max-width: 900px) {
  .dk-chat-stats { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 500px) {
  .dk-chat-stats { grid-template-columns: 1fr; }
}

// ── Chat Grid ──────────────────────────────────────
.dk-chat-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
  margin-top: 16px;
}

// ── Chat Card ──────────────────────────────────────
.dk-chat-card {
  display: flex;
  flex-direction: column;
  background: var(--dk-bg-card, #fff);
  border: 1px solid var(--dk-border, #edf1f4);
  border-radius: 14px;
  overflow: hidden;
  transition: all 0.2s ease;
  box-shadow: var(--dk-shadow-sm, 0 1px 4px rgba(0,0,0,0.05));

  &:hover {
    border-color: rgba($dk-orange, 0.3);
    box-shadow: 0 8px 28px rgba($dk-orange, 0.08), var(--dk-shadow-md);
    transform: translateY(-2px);
  }
}

.dk-chat-card__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 0;
}

.dk-chat-card__avatar-wrap {
  position: relative;
  flex-shrink: 0;
}

.dk-chat-card__avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid var(--dk-border, #edf1f4);
}

.dk-chat-card__status-dot {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid var(--dk-bg-card, #fff);

  &--on { background: #28c76f; }
  &--off { background: #aab0bc; }
}

.dk-chat-card__actions {
  display: flex;
  align-items: center;
  gap: 4px;
}

.dk-chat-card__more-btn {
  background: none;
  border: none;
  padding: 4px;
  border-radius: 6px;
  color: var(--dk-text-faint, #b0bac4);
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: all 0.15s;

  &:hover {
    background: rgba($dk-orange, 0.08);
    color: $dk-orange;
  }
}

.dk-chat-card__body {
  padding: 14px 16px 10px;
  cursor: pointer;
  flex: 1;
  min-height: 60px;
}

.dk-chat-card__name {
  display: block;
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--dk-text-primary, $dk-navy);
  margin-bottom: 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dk-chat-card__msg {
  display: block;
  font-size: 0.78rem;
  color: var(--dk-text-muted, #8a94a6);
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  ::v-deep strong { color: var(--dk-text-secondary, #475569); font-weight: 600; }
  ::v-deep p { margin: 0; }
}

.dk-chat-card__domain {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 8px;
}

.dk-chat-card__domain-icon {
  color: var(--dk-text-muted, #8a94a6);
  flex-shrink: 0;
}

.dk-chat-card__domain-text {
  font-size: 0.72rem;
  color: var(--dk-text-muted, #8a94a6);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;

  &--empty {
    font-style: italic;
    opacity: 0.6;
  }
}

.dk-chat-card__footer {
  padding: 0 16px 14px;
  display: flex;
  gap: 8px;
}

.dk-chat-card__edit-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 8px;
  border: 1.5px solid rgba($dk-orange, 0.3);
  background: transparent;
  color: $dk-orange;
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  width: 100%;
  justify-content: center;

  &:hover {
    background: $dk-orange;
    border-color: $dk-orange;
    color: #fff;
  }
}

// ── Empty state ──────────────────────────────────
.dk-chat-empty {
  grid-column: 1 / -1;
  text-align: center;
  padding: 56px 24px;
  color: var(--dk-text-muted, #8a94a6);

  p { font-size: 0.9rem; font-weight: 600; margin: 14px 0 4px; }
}
.dk-chat-empty__sub {
  font-size: 0.78rem;
  color: var(--dk-text-faint, #b0bac4);
}

// ── Embed modal (legacy) ─────────────────────────
.el-icon-document-copy {
  padding: 1px;
  font-size: 25px;
  color: var(--dk-text-primary, #2e2e2f);
  transition: color .15s linear;
}

#texto {
  color: var(--dk-text-primary, black);
  height: 214px;
  font-size: large;
  font-family: Verdana;
}

.ant-input {
  box-sizing: border-box;
  width: 100%;
  padding: 7px 11px;
  color: var(--dk-text-primary, rgba(24,8,8,0.85));
  font-size: 14px;
  line-height: 1.5715;
  background-color: var(--dk-bg-card, #fff);
  border: 1px solid var(--dk-border-input, #d9d9d9);
  border-radius: 4px;
  transition: all .3s;
}

.avatar { height: 33px; }

@media (max-width: 600px) {
  .dk-chat-grid { grid-template-columns: 1fr; }
  .dk-create-flow__grid { grid-template-columns: 1fr; }
}

// ── Trial expired block ────────────────────────
.dk-chat-grid--disabled {
  filter: blur(4px);
  pointer-events: none;
  user-select: none;
  opacity: 0.5;
}

.dk-trial-chat-block {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
}

.dk-trial-chat-block__card {
  text-align: center;
  padding: 36px 44px;
  background: var(--dk-bg-card, #fff);
  border-radius: 18px;
  border: 2px solid rgba($dk-orange, 0.2);
  box-shadow: 0 12px 40px rgba($dk-navy, 0.1);
  max-width: 440px;
}

.dk-trial-chat-block__icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba($dk-orange, 0.12), rgba(#F5B935, 0.08));
  color: $dk-orange;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 18px;
}

.dk-trial-chat-block__title {
  font-size: 1.15rem;
  font-weight: 800;
  color: $dk-navy;
  margin: 0 0 10px;
}

.dk-trial-chat-block__text {
  font-size: 0.85rem;
  color: #6b7280;
  line-height: 1.6;
  margin: 0 0 22px;
}

.dk-trial-chat-block__btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 32px;
  background: linear-gradient(135deg, $dk-orange, #f08535);
  color: #fff;
  font-size: 0.9rem;
  font-weight: 700;
  border-radius: 10px;
  text-decoration: none;
  transition: all 0.15s;
  box-shadow: 0 4px 14px rgba($dk-orange, 0.35);

  &:hover {
    background: linear-gradient(135deg, darken($dk-orange, 8%), $dk-orange);
    transform: translateY(-1px);
    box-shadow: 0 6px 20px rgba($dk-orange, 0.45);
    color: #fff;
  }
}
</style>

<style lang="scss">
/* Renderizado via portal no body: precisa ser global (não scoped) */
.dk-create-flow-modal .modal-content {
  background: #111827 !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.55) !important;
}

.dk-create-flow-modal .modal-header {
  background: #111827 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.07) !important;
}

.dk-create-flow-modal .modal-title {
  color: #e2e8f0 !important;
  font-weight: 700 !important;
}

.dk-create-flow-modal .close {
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  outline: none !important;
  width: 28px !important;
  height: 28px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: rgba(255, 255, 255, 0.6) !important;
  text-shadow: none !important;
  opacity: 1 !important;
  font-size: 26px !important;
  line-height: 1 !important;
}

.dk-create-flow-modal .close:hover {
  color: #ffffff !important;
}

.dk-create-flow-modal .close span {
  color: inherit !important;
  line-height: 1 !important;
  transform: translateY(-1px);
}

.dk-create-flow-modal .modal-body {
  background: #111827 !important;
  color: #e2e8f0 !important;
}

.dk-create-flow-modal .dk-create-flow__intro {
  color: rgba(255, 255, 255, 0.62) !important;
}

.dk-create-flow-modal .dk-create-flow__section-title {
  color: #e2e8f0 !important;
}

.dk-create-flow-modal .dk-create-flow__item {
  background: #0f1724 !important;
  border-color: rgba(255, 255, 255, 0.09) !important;
}

.dk-create-flow-modal .dk-create-flow__item:hover {
  border-color: rgba(232, 106, 16, 0.45) !important;
  box-shadow: 0 10px 24px rgba(232, 106, 16, 0.2) !important;
}
</style>
